import { StaticContentHandler } from "../StaticContentHandler";
import { IHandler } from "../IHandler";
import { IStaticContent } from "../IStaticContent";

export class DefaultStaticContentHandler extends StaticContentHandler implements IHandler {

	protected async canHandle(): Promise<boolean> {
		return Promise.resolve(true);
	}

	protected selfHandle(): Promise<IStaticContent> {

		return Promise.resolve({
			faqs: [],
			staticText: ""
		});
	}
}
